import React, { useContext, useState } from 'react';

interface ContextProps {
    children: React.ReactNode;
}

type AppSettingsStateContextType = {
    isGettingAppSettings: boolean;
    isGettingApiEndpoints: boolean;
    setGettingAppSettings: (setting: boolean) => void;
    setIsGettingApiEndpoints: (setting: boolean) => void;
};

export const AppSettingsStateContext = React.createContext<AppSettingsStateContextType>(undefined!);

export const AppSettingsStateProvider = ({ children }: ContextProps) => {
    const [isGettingAppSettings, setGettingAppSettings] = useState<boolean>(true);
    const [isGettingApiEndpoints, setIsGettingApiEndpoints] = useState<boolean>(true);

    return (
        <AppSettingsStateContext.Provider
            value={{
                isGettingAppSettings,
                setGettingAppSettings,
                isGettingApiEndpoints,
                setIsGettingApiEndpoints,
            }}
        >
            {children}
        </AppSettingsStateContext.Provider>
    );
};

export const useAppSettingsStateStore = () => useContext(AppSettingsStateContext);
